import { connect } from 'react-redux';
import WalletRowComponent from './WalletRowComponent';
import { getProductByIdSelector } from 'apex-web/lib/redux/selectors/productPositionSelectors';
import { selectPositionAndSave } from 'apex-web/lib/redux/actions/positionActions';
import resize from 'apex-web/lib/hocs/resize';
import { isSelectedAccountRetirementSelector } from '../../redux/selectors/accountSelectors';

const mapStateToProps = (state, ownProps) => {
  const {
    iconFileName,
    ProductSymbol,
    ProductFullName,
    ProductType,
    ProductId,
    DepositEnabled,
    WithdrawEnabled
  } = getProductByIdSelector(state, ownProps.productId);
  const isCrypto = ProductType === 'CryptoCurrency';

  const isSelectedAccountRetirement = isSelectedAccountRetirementSelector(
    state
  );

  const isWithdrawAllowed = WithdrawEnabled && !isSelectedAccountRetirement;
  const isDepositAllowed = DepositEnabled && !isSelectedAccountRetirement;

  return {
    iconFileName,
    ProductSymbol,
    ProductFullName,
    isCrypto,
    ProductId,
    detailsLink: ownProps.detailsLink,
    isWithdrawAllowed,
    isDepositAllowed
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    selectPositionAndSave: () => {
      dispatch(selectPositionAndSave(ownProps.productId));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(resize(WalletRowComponent));
